export default __webpack_public_path__ + "static/media/icon-sales-rep.a3b9143a.svg";